// import compose from 'lodash/fp/compose';
import pipe from 'lodash/fp/pipe';

import { STAGE_ELEMENT_TYPES } from 'pluginServices/editorState/constants';

import { getId } from './getters';
import { not } from './utils';

/**
 * @func hasNoId
 * @param {Array<Object>} data
 * @return {Boolean}
 *
 * (data: Object[]) => Boolean
  * */
export const hasNoId = (data) => {
  const _flow = pipe(getId, not);
  return _flow(data);
};

/**
 * @func hasValidIndex
 * @param {[*, Number]} keyPath
 * @return {Boolean}
 *
 * (keyPath: (any, Number)) => Boolean
  * */
export const hasValidIndex = ([branch, index]) => !isNaN(index) && !!branch;

export const isNotPlugin = (el) => el.type !== STAGE_ELEMENT_TYPES.PLUGIN;

export const isStageSection = (element) =>
  element?.rows != undefined && element.type == undefined; // eslint-disable-line eqeqeq
